import InteriorDesignForm from "../component/InteriorDesignForm";

const InteriorDesignCreate = () => {
  return <InteriorDesignForm isEditMode={false} />;
};

export default InteriorDesignCreate;
